import { isBotUserAgent } from './botAccounts';

/** Best-effort analytics gate, not an abuse/authentication boundary. */
export function isAutomationBrowser(browser = typeof window === 'undefined' ? null : window) {
  const nav = browser?.navigator;
  if (!nav) return false;
  const ua = nav.userAgent || '';
  if (isBotUserAgent(ua) || nav.webdriver === true) return true;
  if (!nav.languages || nav.languages.length === 0) return true;
  // Require both dimensions: one zero can be a browser/window quirk.
  if (browser.outerWidth === 0 && browser.outerHeight === 0) return true;

  const mobileOrEmbedded = /android|mobile|iphone|ipad|ipod|crios|fxios|edgios|\bwv\b|fban|fbav|instagram|line\/|micromessenger|electron/i.test(ua)
    || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);
  const desktopChrome = /(?:Chrome|Chromium)\/\d+/i.test(ua)
    && /windows nt|macintosh|x11|cros|linux x86_64/i.test(ua)
    && !mobileOrEmbedded;
  // Empty plugins are legitimate when inline PDF viewing is disabled. Also
  // leave missing plugin APIs alone (embedded/privacy browsers).
  return desktopChrome && nav.plugins?.length === 0 && nav.pdfViewerEnabled !== false;
}
